export default function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-5 border-y ${
        dark ? "bg-brand-deep border-gold/20" : "bg-gold border-brand/15"
      }`}
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className={`flex items-center gap-6 px-6 font-display font-bold uppercase tracking-[0.2em] text-sm md:text-base whitespace-nowrap ${
                  dark ? "text-gold/90" : "text-brand-deep"
                }`}
              >
                {item}
                <span className={`text-lg ${dark ? "text-gold" : "text-brand"}`}>✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
